import React from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { cn } from "../../lib/utils";

export const StatsCard = ({
  title,
  value,
  prefix = "",
  suffix = "",
  icon: Icon,
  trend,
  trendLabel,
  className,
  delay = 0,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.5 }}
      className={cn(
        "relative p-6 rounded-xl bg-card border border-border overflow-hidden group hover:border-primary/50 transition-all",
        className
      )}
      data-testid={`stats-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
    >
      {/* Background glow effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
      
      <div className="relative flex items-start justify-between">
        <div>
          <p className="text-sm text-muted-foreground font-medium mb-1">{title}</p>
          <p className="text-3xl font-heading font-black tracking-tight">
            {prefix}
            <CountUp
              end={typeof value === "number" ? value : 0}
              duration={2}
              separator=","
              decimals={value > 1000000 ? 1 : 0}
            />
            {suffix}
          </p>
          
          {trend !== undefined && (
            <div className="mt-2 flex items-center gap-1">
              <span
                className={cn(
                  "text-xs font-medium",
                  trend >= 0 ? "text-green-500" : "text-red-500"
                )}
              >
                {trend >= 0 ? "+" : ""}
                {trend}%
              </span>
              {trendLabel && (
                <span className="text-xs text-muted-foreground">{trendLabel}</span>
              )}
            </div>
          )}
        </div>
        
        {Icon && (
          <div className="h-12 w-12 rounded-xl bg-primary/10 flex items-center justify-center">
            <Icon className="h-6 w-6 text-primary" />
          </div>
        )}
      </div>
    </motion.div>
  );
};

export const StatsGrid = ({ children, columns = 4 }) => {
  return (
    <div
      className={cn(
        "grid gap-4",
        columns === 2 && "grid-cols-1 sm:grid-cols-2",
        columns === 3 && "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
        columns === 4 && "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"
      )}
      data-testid="stats-grid"
    >
      {children}
    </div>
  );
};

export default StatsCard;
